/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";

function FinancialYear({ selectedYear, setSelectedYear }) {

    const getCurrentFinancialYear = () => {
        const currentYear = new Date().getFullYear()
        const currentMonth = new Date().getMonth() + 1
        if (currentMonth >= 4) {
            return { value: currentYear.toString(), label: `${currentYear}-${currentYear + 1}` }
        } else {
            return { value: (currentYear - 1).toString(), label: `${currentYear - 1}-${currentYear}` }
        }
    }

    useEffect(() => {
        const storedYear = sessionStorage.getItem("financialYear")
        if (storedYear) {
            const parsedYear = JSON.parse(storedYear)
            setSelectedYear(parsedYear.value)
            sessionStorage.setItem("CurrentYearCP", parsedYear.value)
        } else {
            const currentYear = getCurrentFinancialYear()
            sessionStorage.setItem("financialYear", JSON.stringify(currentYear))
            sessionStorage.setItem("CurrentYearCP", currentYear.value)
            setSelectedYear(currentYear.value)
        }
    }, [])

    const handleChange = (e) => {
        const selectedOption = {
            value: e.target.value,
            label: e.target.options[e.target.selectedIndex].text
        };
        sessionStorage.setItem("financialYear", JSON.stringify(selectedOption))
        sessionStorage.setItem("CurrentYearCP", selectedOption.value)
        setSelectedYear(selectedOption.value)
    };

    return (
        <select
            className="form-control form-select"
            name="financialyear"
            value={selectedYear || "none"}
            onChange={(e) => handleChange(e)}
        >
            <option value="none" hidden disabled>
                {selectedYear === "" || selectedYear === null ? "SELECT A FINANCIAL YEAR" : selectedYear}
            </option>
            <option value="2023" id="2023">2023-2024</option>
            <option value="2024" id="2024">2024-2025</option>
        </select>
    );
}

export default FinancialYear;
